import React, { Component } from 'react';

import scrollTo from '../../lib/scroll-to';

class Link extends Component {
    constructor(props) {
        super(props);
        this.scrollToHash = this.scrollToHash.bind(this);
    }

    scrollToHash(e) {
        e.preventDefault();
        this.props.handleMenuToggle(e);
        const { href } = this.props;
        if (href.substring(0, 1) === '#') {
            const hash = href.substring(1);
            const elem = document.getElementById(hash);
            if (elem) {
                const rect = elem.getBoundingClientRect();
                const scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
                const scrollTop = rect.top + scrollY;
                scrollTo(scrollTop, null, 800);
            }
        }
    }

    render() {
        const {
            type, href, className, children, title
        } = this.props;

        if (type === 'internal') {
            return (
                <a href={ href } className={ className } title={ title } onClick={ this.scrollToHash }>
                    { children }
                </a>
            );
        }
        return null;
    }
}

Link.defaultProps = {
    type: 'none',
    href: null,
    className: null,
    children: null,
    title: undefined
};

export default Link;
